import React, { useEffect, useState } from 'react';

import UiBtnLoader from '../ui/ui-btn-loader/ui-btn-loader';
import LoadedIcon from 'assets/icons/file-loaded.svg';

import './file-loader.scss';

interface FileLoaderProps {
  label?: string;
  onFileReady: (file: File) => void;
  fileNameProp?: string;
}

const FileLoader: React.FC<FileLoaderProps> = ({
  label,
  fileNameProp,
  onFileReady,
}) => {
  const [fileName, setFilename] = useState<string>(
    fileNameProp ? fileNameProp : ''
  );

  useEffect(() => {
    if (fileNameProp) setFilename(fileNameProp);
  }, [fileNameProp]);

  const loadedBody = (
    <div className="file-loader__load">
      <p className="file-loader__text-loaded">{fileName}</p>
    </div>
  );

  return (
    <div className="file-loader">
      <div className="file-loader__left">
        <p className="file-loader__title">{label}</p>
        {fileName && loadedBody}
      </div>
      <div className="file-loader__right">
        {!fileNameProp ? (
          <UiBtnLoader
            onFileReady={(file) => {
              onFileReady(file);
            }}
          />
        ) : (
          <img src={LoadedIcon} alt={fileNameProp} />
        )}
      </div>
    </div>
  );
};

export default FileLoader;
